(function($){

    if ( $('.nl4wp-form').length == 0) {
        return;
    }
    $(document).on(
        'ready',
        function() {
            $('#registration-submit').on(
                'click',
                function() {
                    if ($('#agree-to-terms').is(':checked')) {
                        $('.nl4wp-form-32261').get(0).submit();
                    } else {
                        $('.nl4wp-response').empty();
                        $notice = $('<p>').text('Devi prestare il consenso all\'invio della newsletter');
                        $error = $('<div>').addClass('nl4wp-alert nl4wp-error');
                        $error.append($notice);
                        $('.nl4wp-response').append($error);
                    }
                }
            );
        }
    );
    $(window).on(
        'load',
        function() {
            if ( $('.nl4wp-error').length > 0 ) {
                $('#newsletter-modal').modal('show');
            }

            if ( $('.nl4wp-notice').length > 0 ) {
                $('#newsletter-modal').modal('show');
            }

            $('#newsletter-modal').on(
                'hidden.bs.modal',
                function() {
                    $('form', '#newsletter-modal').get(0).reset();
                    $('.nl4wp-response', '#newsletter-modal').empty();
                }
            )
        }
    );
})(jQuery.noConflict())